import { api } from "@/lib/api";

const KEY = "resonance.pendingUploads";
const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { return {}; } };
const write = (m) => localStorage.setItem(KEY, JSON.stringify(m));

export const fingerprint = (file, base) => `${base}|${file.name}|${file.size}|${file.lastModified}`;

export const rememberUpload = (fp, info) => write({ ...read(), [fp]: { ...info, at: Date.now() } });
export const forgetUpload = (fp) => { const m = read(); delete m[fp]; write(m); };

export const findResumable = async (file, base) => {
  const fp = fingerprint(file, base);
  const info = read()[fp];
  if (!info) return null;
  try {
    const { data } = await api.get(`${base}/uploads/${info.upload_id}`);
    if (data.size !== file.size) throw new Error("size mismatch");
    return { fp, ...data };
  } catch {
    forgetUpload(fp);
    return null;
  }
};

export const runPool = async (jobs, concurrency) => {
  const queue = [...jobs];
  const worker = async () => { for (let job = queue.shift(); job; job = queue.shift()) await job(); };
  await Promise.all(Array.from({ length: Math.min(concurrency, jobs.length) }, worker));
};
